module.exports = __webpack_public_path__ + "img/singapore-25.27719603.png";